/* istanbul ignore file */
import PropTypes from 'prop-types';

export const Image = PropTypes.shape({
  title: PropTypes.string.isRequired,
  file: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
});

export const Author = PropTypes.shape({
  displayTitle: PropTypes.string.isRequired,
  mainImage: Image.isRequired,
});

export const MainImage = PropTypes.shape({
  image: Image,
  entryTitle: PropTypes.string,
  contentfulId: PropTypes.string,
  imageAltText: PropTypes.string,
  imageCaption: PropTypes.string,
  displayTitle: PropTypes.string,
});

export const ImageGroupPropType = PropTypes.shape({
  contentfulId: PropTypes.string,
  title: PropTypes.string,
  _updatedAt: PropTypes.string,
  file: PropTypes.shape({
    contentType: PropTypes.string,
    fileName: PropTypes.string,
    url: PropTypes.string,
    details: PropTypes.shape({
      size: PropTypes.number,
      image: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
      }),
    }),
  }),
});

export const AvatarItemPropType = PropTypes.shape({
  externalId: PropTypes.string,
  contentfulId: PropTypes.string,
  entryName: PropTypes.string,
  displayName: PropTypes.string,
  description: PropTypes.string,
  eventName: PropTypes.string,
  defaultSetItem: PropTypes.bool,
  slot: PropTypes.string,
  previewIcon: PropTypes.shape({}),
  previewImage: PropTypes.shape({}),
  primaryImage: PropTypes.shape({}),
  secondaryImage: PropTypes.shape({}),
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      entryName: PropTypes.string,
      displayName: PropTypes.string,
      colorHexCode: PropTypes.string,
      primaryImage: PropTypes.shape({}),
      secondaryImage: PropTypes.shape({}),
    }),
  ),
});

export const ProfileRootContentType = PropTypes.shape({
  wandIndex: PropTypes.shape({}),
  wandImages: PropTypes.shape({}),
  patronusImages: PropTypes.shape({}),
});
